{
    "services-personalized-advisors": {
        "meta": {
            "title": "Personalized Advisors - MAJORITY",
            "description": "We speak your language. Get help with MAJORITY from any of our trained, personalized advisors."
        },
        "hero": {
            "title": "Personalized advisors",
            "body": "Dedicated customer support in your language whenever you need it.",
            "cta": "Get started",
            "features": "Dedicated customer support\nCurated community content"
        },
        "we_speak_content_box": {
            "tagline": "Personalized advisors",
            "title": "We speak your language",
            "body": "We have advisors ready to help you at a moment’s notice in your own language. Most of our advisors are also migrants themselves, so they have personal knowledge of how difficult it can be to build a financial foundation in a new country. Whether you have questions about your account, Visa® Debit Card, sending money and top-ups, or making international calls, our dedicated customer support is here for you.",
            "canvas": "How can we help you?"
        },
        "welcome_content_box": {
            "tagline": "Personalized advisors",
            "title": "Welcome to the neighborhood",
            "body": "Whether you have questions about personal finance, budgeting, or adjusting to life in the US, you’ll find the answer in our personally curated Community content. Discover inspirational stories about fellow community members, local business leaders, and migrant entrepreneurs. Share your story with us for your own chance to be featured!",
            "cta": "Visit the community"
        }
    }
}